import "./App.css";
import { HashRouter, Route, Routes } from "react-router-dom";
import HomePage from "./pages/Home/Home";
import Dashboard from "./pages/Dashboard/Dashboard";
import EducationPage from "./pages/Education/Education";
import MainLayout from "./layouts/MainLayout";
import { useState } from "react";
import ProgramsPage from "./pages/Programs/Programs";
import LibraryPage from "./pages/Library/Library";
import BooksPage from "./pages/books/books";
import AboutDetailed from "./pages/About/AboutDetails";
import NewsPage from "./pages/NewsPage/NewsPage";

function App() {
  const [language, setLanguage] = useState("ar");
  const [activeSection, setActiveSection] = useState("home");

  const toggleLanguage = () => {
    console.log("Clicked");
    setLanguage(language === "ar" ? "en" : "ar");
  };

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <HashRouter>
      <div
        className="min-h-screen bg-gradient-to-b from-green-50 to-white"
        dir={language === "ar" ? "rtl" : "ltr"}
      >
        <Routes>
          {/* Home + Education share the header */}

          <Route
            path="/"
            element={
              <MainLayout
                language={language}
                toggleLanguage={toggleLanguage}
                activeSection={activeSection}
                scrollToSection={scrollToSection}
              >
                <HomePage
                  language={language}
                  activeSection={activeSection}
                  scrollToSection={scrollToSection}
                />
              </MainLayout>
            }
          />

          <Route
            path="/education"
            element={
              <MainLayout
                language={language}
                toggleLanguage={toggleLanguage}
                activeSection={activeSection}
                scrollToSection={scrollToSection}
              >
                <EducationPage language={language} />
              </MainLayout>
            }
          />

          <Route
            path="/news/:id"
            element={
              <MainLayout
                language={language}
                toggleLanguage={toggleLanguage}
                activeSection={activeSection}
                scrollToSection={scrollToSection}
              >
                <NewsPage language={language} />
              </MainLayout>
            }
          />

          <Route
            path="/programs"
            element={
              <MainLayout
                language={language}
                toggleLanguage={toggleLanguage}
                activeSection={activeSection}
                scrollToSection={scrollToSection}
              >
                <ProgramsPage language={language} />
              </MainLayout>
            }
          />

          <Route
            path="/library"
            element={
              <MainLayout
                language={language}
                toggleLanguage={toggleLanguage}
                activeSection={activeSection}
                scrollToSection={scrollToSection}
              >
                <LibraryPage language={language} />
              </MainLayout>
            }
          />

          <Route
            path="/books"
            element={
              <MainLayout
                language={language}
                toggleLanguage={toggleLanguage}
                activeSection={activeSection}
                scrollToSection={scrollToSection}
              >
                <BooksPage language={language} />
              </MainLayout>
            }
          />

          <Route
            path="/about"
            element={
              <MainLayout
                language={language}
                toggleLanguage={toggleLanguage}
                activeSection={activeSection}
                scrollToSection={scrollToSection}
              >
                <AboutDetailed language={language} />
              </MainLayout>
            }
          />

          {/* Dashboard = NO HEADER */}
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </div>
    </HashRouter>
  );
}

export default App;
